module.exports = __webpack_public_path__ + "img/hacienda-room-8.0f65b2c5.jpg";